import React from "react";
import PropTypes from "prop-types";

import CssBaseline from "@material-ui/core/CssBaseline";
import { withStyles } from "@material-ui/core/styles";

import AdminDrawer from "./AdminDrawer";
import AdminNavigationBar from "./AdminNavigationBar";

const styles = theme => ({
  root: {
    display: "flex"
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto"
  },
});

class Dashboard extends React.PureComponent {
  state = {
    open: false
  };

  handleDrawer = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>

          <AdminNavigationBar 
            open={this.state.open}
            handleDrawer={this.handleDrawer}
            history={this.props.history}
          />
          

          <AdminDrawer
            open={this.state.open}
            handleDrawer={this.handleDrawer}
            history={this.props.history}
          />

          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            {/* {this.changePage()} */}
            {this.props.children}
          </main>
        </div>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Dashboard);
